/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { ReactElement } from 'react';

export const MessageSaisieTrim = `Si vous ne souhaitez pas détailler les notes par trimestre,
vous pouvez ne saisir que le premier trimestre,
qui sera considéré comme la moyenne annuelle.

Si vous ne saisissez aucune note, la matière sera
ignorée dans le calcul des points et de la note finale.`;
export const MessageSaisieTrimestres = `Saisissez votre note sur 20, arrondie `;

export const MessagePointsAuDessus10 = `seuls les points
au-dessus de 10 comptent`;

export interface ShareCode {
  p: number;
  n: number;
  f: string;
}

export interface Matiere {
  name: keyof SimulationBaseNotes;
  label: string;
  coef: number;
  facultatif?: boolean;
  pointsAuDessus10?: boolean;
  spe?: boolean;
}

// options
export const COEF_OPTION1_LATIN_GREC = 3;
export const COEF_OPTION1 = 2;
export const COEF_OPTION2 = 1;

export const tabNotesOptions = [
  {
    name: 'option_1',
    label: 'Option n°1',
    coef: COEF_OPTION1,
    pointsAuDessus10: true,
  },
  {
    name: 'option_2',
    label: 'Option n°2',
    coef: COEF_OPTION2,
    pointsAuDessus10: true,
  },
] as Matiere[];

export interface EtapeSaisie {
  composant: ReactElement;
  afficher: boolean;
}
export interface Rubrique {
  nomRubrique: string;
  vide: boolean;
  etapes: EtapeSaisie[];
}

export interface SimulationBase {
  filiere: '' | 'L' | 'ES' | 'S' | 'STMG';
  sous_filiere: '' | 'S-SVT' | 'S-Écologie, agronomie et territoires' | 'S-Sciences de l’ingénieur';
  specialite: string;
  nb_options: '' | 'Aucune' | '1' | '2';
  latin_ou_grec: '' | 'Oui' | 'Non';

  points: number;
  nbTotalPoints: number;
}

export interface SimulationBaseNotes {
  francais_ecrit: '' | number;
  francais_oral: '' | number;
  sciences: '' | number;
  TPE: '' | number;
  etude_gestion: '' | number;

  eco_appr: '' | number;
  SSP: '' | number;
  maths_spe: '' | number;

  hist_geo: '' | number;
  maths: '' | number;
  PC: '' | number;
  SVT: '' | number;
  EAT: '' | number;
  SI: '' | number;
  ISN: '' | number;
  SES: '' | number;
  LV1: '' | number;
  LV2: '' | number;
  philo: '' | number;
  EPS: '' | number;
  EPS_comp: '' | number;

  spe_l_4: '' | number;
  spe_l_3_3: '' | number;
  litt: '' | number;
  litt_etr: '' | number;


  option_1: '' | number;
  option_2: '' | number;
};

export interface NotesTrimestre {
  eco_appr_t: ('' | number)[];
  SSP_t: ('' | number)[];
  maths_spe_t: ('' | number)[];

  hist_geo_t: ('' | number)[];
  maths_t: ('' | number)[];
  PC_t: ('' | number)[];
  SVT_t: ('' | number)[];
  EAT_t: ('' | number)[];
  SI_t: ('' | number)[];
  ISN_t: ('' | number)[];
  SES_t: ('' | number)[];
  LV1_t: ('' | number)[];
  LV2_t: ('' | number)[];
  philo_t: ('' | number)[];
  EPS_t: ('' | number)[];
  EPS_comp_t: ('' | number)[];

  spe_l_4_t: ('' | number)[];
  spe_l_3_3_t: ('' | number)[];
  litt_t: ('' | number)[];
  litt_etr_t: ('' | number)[];

  option_1_t: ('' | number)[];
  option_2_t: ('' | number)[];
}
export type Simulation = SimulationBase & SimulationBaseNotes & NotesTrimestre;


export const simulationBaseVide: SimulationBase = {
  filiere: '',
  sous_filiere: '',
  specialite: '',
  nb_options: 'Aucune',
  latin_ou_grec: 'Non',

  points: 0,
  nbTotalPoints: 0,
}

export const simulationBaseNotesVide: SimulationBaseNotes = {
  francais_ecrit: '',
  francais_oral: '',
  sciences: '',
  TPE: '',
  etude_gestion: '',

  eco_appr: '',
  SSP: '',
  maths_spe: '',
  hist_geo: '',
  maths: '',
  PC: '',
  SVT: '',
  EAT: '',
  SI: '',
  ISN: '',
  SES: '',
  LV1: '',
  LV2: '',
  philo: '',
  EPS: '',
  EPS_comp: '',
  spe_l_4: '',
  spe_l_3_3: '',
  litt: '',
  litt_etr: '',

  option_1: '',
  option_2: '',
}
export const NotesTrimestreVide: NotesTrimestre = {
  eco_appr_t: ['', '', ''],
  SSP_t: ['', '', ''],
  maths_spe_t: ['', '', ''],
  hist_geo_t: ['', '', ''],
  maths_t: ['', '', ''],
  PC_t: ['', '', ''],
  SVT_t: ['', '', ''],
  EAT_t: ['', '', ''],
  SI_t: ['', '', ''],
  ISN_t: ['', '', ''],
  SES_t: ['', '', ''],
  LV1_t: ['', '', ''],
  LV2_t: ['', '', ''],
  philo_t: ['', '', ''],
  EPS_t: ['', '', ''],
  EPS_comp_t: ['', '', ''],
  spe_l_4_t: ['', '', ''],
  spe_l_3_3_t: ['', '', ''],
  litt_t: ['', '', ''],
  litt_etr_t: ['', '', ''],

  option_1_t: ['', '', ''],
  option_2_t: ['', '', ''],
}

export type OptionsBouton = 'oui' | 'non' | 'disabled';

export const simulationVide = { ...simulationBaseVide, ...simulationBaseNotesVide, ...NotesTrimestreVide };


export interface RowDataPacket {
  [x: string]: any;
}

export interface LogoutArg extends DataJsonRequest {
  token: string;
}
export interface LoginArg extends DataJsonRequest {
  emailAddress: string;
}
export interface SignUpArg extends DataJsonRequest {
  emailAddress: string;
  lang: string;
  name?: string;
  surname?: string;
  password: string;
}
export interface ResendVerifCodeArg extends DataJsonRequest {
  emailAddress: string;
  lang: string;
}
export interface ReinitPswArg extends DataJsonRequest {
  emailAddress: string;
  lang: string;
  password: string;
  validationCode: string;
}
export interface ReinitPswSendMailArg extends DataJsonRequest {
  emailAddress: string;
  lang: string;
}
export interface ReinitPswValidCodeSubmissionArg extends DataJsonRequest {
  requestType: string;
  validationCode: string;
  lang: string;
}

export interface DataJsonRequest {
  requestType: string;
  id?: number;
  userId?: number;
  token?: string;
  emailAddress?: string;
  password?: string;
  name?: string;
  surname?: string;
  groupName?: string;
  groupId?: number;
  parent?: number;
  lang?: string;
  validationCode?: string;
  simulation?: Simulation;
  partie?: string;
  CP?: string;
}

export interface ServerResponse {
  success: boolean;
  message: string;
  // lang?   : string;
}

export interface SendEmailResponse extends ServerResponse {
  info: any;
}


export type JsonServerResponse = ServerResponse

export interface JsonLangServerResponse extends ServerResponse {
  values: any;
  noRequestLanguageFound?: boolean;
}

export interface LoginServerResponse extends ServerResponse {
  name: null | string;
  surname: null | string;
  id: number;
  emailAddress: string;
  token: string;
  accountState: number;
}

export interface CheckEmailServerResponse extends ServerResponse {
  id: number;
  accountState: number;
}
export type SignUpServerResponse = ServerResponse

export interface ValidationRequestServerResponse extends ServerResponse {
  id: number;
  name: string;
  surname: string;
  emailAddress: string;
  token: string;
}
export interface ReinitPswSubmissionRequestServerResponse extends ServerResponse {
  userId: number;
  emailAddress: string;
}

export interface Langs {
  availableLanguages: string[];
  [x: string]: any;
}


export interface ModalOptions {
  type                : string;
  message             : React.ReactElement;
  inputInitial?       : string;
  inputPlaceholder?   : string;
  okClickedFunction?  : (groupName?: string) => boolean | void;
}

// export const enum UserDataKeys {
//   emailAddress = 'emailAddress',
//   id = 'id',
//   name = 'name',
//   surname = 'surname',
//   token = 'token',
// }

export interface UserData {
  emailAddress: null | string;
  id: null | number;
  name: null | string;
  surname: null | string;
  token: null | string;
}
export interface PartOfUserData {
  emailAddress?: null | string;
  id?: null | number;
  name?: null | string;
  surname?: null | string;
  token?: null | string;
}
export interface UserFormData extends UserData {
  verificationCode: null | string;
  psw             : null | string;
  pswBis          : null | string;
}

export interface PartOfUserFormData extends PartOfUserData {
  verificationCode?: null | string;
  psw?: null | string;
  pswBis?: null | string;
}

export interface GroupToDisplay {
  id: number;
  name: string;
}

export interface SendJsonServerRequestArgs {
  data:                DataJsonRequest;
  apiPath:              string;
  successCallback?:     (ret:any, argsSuccessCallback?: any) => void;
  argsSuccessCallback?: any;
  failureCallback?:     (ret:any, argsFailureCallback?: any) => void;
  argsFailureCallback?: any;
  mustSignOut?:         boolean;
  signOutFunction?:     () => void;
  displayAlertModal?:   boolean;
  displayAlertModalFunction?: (message: string) => void;
  setEcranChargement: (afficher: boolean, message?: string) => void;
}

export interface Student {
  name: string;
  surname: string;
}
